/**
 * Created by andrey on 21.07.2023
 */

const Map2dBorderView = cc.Node.extend({ 
    ctor: function (borderTile) {
        this._super();

        this.reuse(borderTile);
    },

    unuse: function () {
        for (let i = this.children.length - 1; i >= 0; i--) {
            cleverapps.pool.putInPool(this.children[i]);
        }

        this.removeTemporarily();
    },

    reuse: function (borderTile) {
        this.setScale(1);
        this.setRotation(0);
        this.setAnchorPoint(0.5, 0.5);
        this.setPosition(0, 0);
        this.setOpacity(255);
        this.setVisible(true);

        borderTile.onGetView = this.createListener(() => this);

        this.layer = undefined;
        if (Map2d.currentMap.calcGroundLevel(borderTile.x, borderTile.y)) {
            this.layer = Map2d.LAYER_GROUND;
        }

        borderTile.borders.forEach((border) => {
            this.addChild(Map2dBorderSprite.GetFromPool(border));
        });
    }
});

Map2dBorderView.PoolLimit = 200;

Map2dBorderView.GetFromPool = function (borderTile) {
    return cleverapps.pool.getFromPool(Map2dBorderView, borderTile) || new Map2dBorderView(borderTile);
};